module.exports = __webpack_public_path__ + "img/profile1.5e749b1d.jpg";